import React, { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'store/hooks';
import {
  TechnicianConfirmationSelector,
  VerificationModalOpenSelector,
  ShowTechnicianConfirmationModalSelector,
} from 'store/verificationRequest/selectors';
import { removeTechnicianConfirmationRequest } from 'store/verificationRequest';

import Button from 'components/Button/Button';

import useStyles from './styles';
import { tt } from '@i18n/tt';

const TechnicianConfirmation: React.FC = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const verificationRequest = useAppSelector(TechnicianConfirmationSelector);
  const verificationModalOpen = useAppSelector(VerificationModalOpenSelector);
  const showTechnicianConfirmationModal = useAppSelector(ShowTechnicianConfirmationModalSelector);

  const removeComponent = useCallback(() => {
    dispatch(removeTechnicianConfirmationRequest());
  }, []);

  if (!verificationRequest || verificationModalOpen || !showTechnicianConfirmationModal) {
    return null;
  }
  return (
    <div className={classes.backdrop} onClick={removeComponent}>
      <div className={classes.modal}>
        <div>
          {tt('common.verifiedTheirIdentity')} {verificationRequest.techName}
        </div>
        <div className={classes.buttons}>
          <Button text={tt('buttons.close')} onClick={removeComponent} />
        </div>
      </div>
    </div>
  );
};

export default TechnicianConfirmation;
